import React from 'react';
//import { Image, Col } from 'react-bootstrap';

import './overviewReqComponent.scss'

class OverviewReqComponent extends React.Component {
    render() {
        return <div className="introduction-component">
            <div className="section">
                <h3>EVERY DAY, MILLIONS OF EXERCISERS INTERACT WITH LIFE FITNESS EQUIPMENT.</h3>
                <p>We created an open API to give app developers the opportunity to connect with this audience and join Life Fitness in encouraging people to take the steps needed to live active and healthy lives.</p>
            </div>
        </div>
    }
}

export default OverviewReqComponent



// WEBPACK FOOTER //
// ./src/components/marketingGuidelines/marketingComponents/OverviewRequirements/OverviewReqComponent.js